import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {UserSearchService} from './user-search.service';
import {environment} from 'src/environments/environment';
import {LayoutService} from './layout.service';
import {interval, Subject} from 'rxjs';
import {switchMap, takeUntil} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {Router} from '@angular/router';

@Component({
    templateUrl: './layout.component.html',
    standalone: false
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  open_tasks = 0;
  public me = null;
  timer = interval(300000);
  statusCollapse = false;
  menuOpen = false;
  @ViewChild('navContainer', {static: true})
  navContainer: ElementRef;
  @ViewChild('topNavbar', {static: true})
  topNavbar: ElementRef;
  private navbarResizeObserver: ResizeObserver;
  deployUrl: string;
  tasks = [];
  followed_task = null;
  setMainOverflowVisible = false;
  version = environment.version;
  branchName = environment.branch_name;
  lastCommitTime = environment.last_commit_time;
  lastCommitAuthor = environment.last_commit_author;
  isMainOverflowVisible$;

  private destroy$ = new Subject<void>();

  addTask(task) {
    this.followed_task = task;
  }

  constructor(
    private userSerach: UserSearchService,
    private renderer: Renderer2,
    private layoutService: LayoutService,
    private http: HttpClient,
    private router: Router,
  ) {
    this.isMainOverflowVisible$ = this.layoutService.isMainOverflowVisible$;
  }

  ngOnInit(): void {
    if (!environment.production) {
      console.log('version', this.version);
      console.log(this.lastCommitTime);
      console.log(this.branchName);
    }
    this.userSerach.getMe().pipe(takeUntil(this.destroy$)).subscribe((me: any) => {
      this.me = me;
    });

    this.timer
      .pipe(
        switchMap(() => this.userSerach.getMe()),
        takeUntil(this.destroy$),
      )
      .subscribe(me => {
        this.me = me;
      });

    this.deployUrl = environment.deploy_url;

    this.layoutService.setLeftMenuOpenedState(!this.statusCollapse);

    if (window.matchMedia('(min-width: 1024px) and (max-width: 1260px)').matches) {
      this.collapseNav();
    }
  }

  ngAfterViewInit() {
    this.navbarResizeObserver = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--navbar-height', `${this.topNavbar.nativeElement.offsetHeight}px`);
    });
    this.navbarResizeObserver.observe(this.topNavbar.nativeElement);
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  collapseNav() {
    this.statusCollapse = !this.statusCollapse;
    this.statusCollapse
      ? this.renderer.setStyle(
          this.navContainer.nativeElement,
          'margin-left',
          '-' + this.navContainer.nativeElement.offsetWidth + 'px',
        )
      : this.renderer.setStyle(this.navContainer.nativeElement, 'margin-left', '0px');

    this.layoutService.setLeftMenuOpenedState(!this.statusCollapse);
  }

  goTop(instant = false) {
    if (instant) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    } else {
      const scrollToTop = window.setInterval(() => {
        const pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, pos - 20);
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 2);
    }
  }

  logout() {
    this.http.get('/rest-api/dashboard/logout').subscribe({
      complete: () => this.router.navigate(['/admin/login']),
      error: () => this.router.navigate(['/admin/login']),
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.navbarResizeObserver?.disconnect();
  }
}
